// extracted by mini-css-extract-plugin
module.exports = {"textPlaceholder":"TableLoadingPlaceholder_textPlaceholder__1jUC4"};